import React, { Component } from "react";
import { Link } from "react-router-dom";
import userDB from "../assets/userDB.svg";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full h-screen flex flex-col items-center justify-center">
          <img src={userDB} alt="" />
          <h1 className="text-3xl font-bold mb-4">Something went wrong.</h1>
          <p className="text-lg mb-6">
            We apologize for the inconvenience. Please try again or go back to
            the home page.
          </p>
          <div className="flex justify-center space-x-4">
            <button
              to="/"
              className="bg-pri text-white font-bold py-2 px-4 rounded hover:text-white"
              onClick={() => {
                window.location.replace("/");
              }}
            >
              Go back to home page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
